import useCheckDevice from "@repo/shopify/hooks/useCheckDevice";
import { useEffect, useRef } from "react";

export default function useHeaderScroll() {
  const { isPC } = useCheckDevice();
  const lastScrollTop = useRef(0);

  useEffect(() => {
    if (isPC) return;

    // 1. 이전 스크롤 위치를 기억할 변수를 이벤트 리스너 외부에 선언합니다.
    lastScrollTop.current = window.scrollY || document.documentElement.scrollTop;

    // 2. 이벤트 리스너로 사용할 함수를 분리하여 선언 (클린업을 위해 필요)
    const handleScroll = () => {
      const filter = document.getElementById("filter");
      const header = document.getElementById("header");

      if (!filter || !header) return;

      // 마운트 시점에 트랜지션을 한 번만 부드럽게 설정합니다. (0.3초 동안 스르륵 움직임)
      if (header) {
        header.style.transition = "top 0.3s ease-in-out";
      }

      if (filter) {
        filter.style.transition = "top 0.3s ease-in-out";
      }

      const { top } = filter.getBoundingClientRect();
      const currentScroll = window.scrollY || document.documentElement.scrollTop;

      if (currentScroll > lastScrollTop.current) {
        // 스크롤 내릴 때
        if (top <= 52) {
          header.style.top = "-52px";
          filter.style.top = "0px";
        } else {
          header.style.top = "0px";
          filter.style.top = "52px";
        }
      } else {
        // 스크롤을 올릴 때 (Scrolling UP)
        if (top <= 52) {
          header.style.top = "0px";
          filter.style.top = "52px";
        }
      }

      // 4. 스크롤 위치 업데이트 (iOS 바운스 효과 방지)
      lastScrollTop.current = Math.max(0, currentScroll);
    };

    handleScroll();

    // 5. 스크롤 이벤트 등록
    window.addEventListener("scroll", handleScroll);

    // 6. 컴포넌트 언마운트 시 이벤트 해제 (클린업 함수)
    return () => {
      const header = document.getElementById("header");
      if (!header) return;
      header.style.transition = "";
      header.style.top = "0px";

      window.removeEventListener("scroll", handleScroll);
    };
  }, [isPC]);
}
